/* ==========================================================================
   Clippiq teması — çekirdek davranışlar
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;

  /* --------------------------------------------------------------------
     Yardımcılar
     -------------------------------------------------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var fmt = window.clpTheme && window.clpTheme.moneyFormat;
    var value = (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (!fmt) return value + ' TL';
    var out = fmt.replace(/\{\{\s*amount\s*\}\}/, value)
                 .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toLocaleString('tr-TR'))
                 .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value);
    // Mağaza biçimi "{{amount}}TL" gibi bitişik yazıyor; Türkçede araya boşluk girer.
    return out.replace(/\s*TL\s*$/, ' TL').replace(/^₺\s+/, '₺');
  }


  /* --------------------------------------------------------------------
     Yatay yumuşak kaydırma
     Bazı tarayıcılarda scroll-snap + behavior:'smooth' birlikte çalışmıyor;
     bu yüzden animasyonu kendimiz sürüyoruz. Her yerde aynı davranır.
     -------------------------------------------------------------------- */
  function scrollXTo(el, target, duration) {
    if (!el) return;
    var max = el.scrollWidth - el.clientWidth;
    target = Math.max(0, Math.min(max, target));
    if (reducedMotion()) { el.scrollLeft = target; return; }
    var start = el.scrollLeft;
    var delta = target - start;
    if (Math.abs(delta) < 1) return;
    var dur = duration || 480;
    var t0 = performance.now();
    if (el._clpScrollRaf) cancelAnimationFrame(el._clpScrollRaf);

    // scroll-snap animasyon sırasında her karede geri çekiyor; geçici kapat.
    var snap = el.style.scrollSnapType;
    el.style.scrollSnapType = 'none';

    (function step(now) {
      var p = Math.min(1, (now - t0) / dur);
      var eased = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      el.scrollLeft = start + delta * eased;
      if (p < 1) {
        el._clpScrollRaf = requestAnimationFrame(step);
      } else {
        el._clpScrollRaf = null;
        el.style.scrollSnapType = snap;
      }
    })(t0);
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  window.clpScrollXTo = scrollXTo;

  var scrollLockCount = 0;
  function lockScroll() {
    if (scrollLockCount === 0) {
      body.dataset.clpScrollY = String(window.scrollY);
      body.style.position = 'fixed';
      body.style.top = '-' + window.scrollY + 'px';
      body.style.width = '100%';
    }
    scrollLockCount++;
  }
  function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
      var y = parseInt(body.dataset.clpScrollY || '0', 10);
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      window.scrollTo(0, y);
    }
  }

  /* --------------------------------------------------------------------
     Panel (drawer) yöneticisi
     -------------------------------------------------------------------- */
  var overlay = null;
  var openPanels = [];

  function ensureOverlay() {
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.className = 'clp-overlay';
    overlay.addEventListener('click', function () { closeAllPanels(); });
    body.appendChild(overlay);
    return overlay;
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([type=hidden]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var lastFocused = null;

  function trapFocus(e) {
    if (e.key !== 'Tab' || !openPanels.length) return;
    var panel = openPanels[openPanels.length - 1];
    var items = $$(FOCUSABLE, panel).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openPanel(el) {
    if (!el || el.classList.contains('is-open')) return;
    if (!openPanels.length) lastFocused = document.activeElement;
    ensureOverlay().classList.add('is-open');
    el.classList.add('is-open');
    el.removeAttribute('aria-hidden');
    openPanels.push(el);
    lockScroll();
    var focusable = el.querySelector('input:not([type=hidden]), button, a[href]');
    if (focusable) setTimeout(function () { focusable.focus(); }, 320);
  }

  function closePanel(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    openPanels = openPanels.filter(function (p) { return p !== el; });
    if (!openPanels.length) {
      if (overlay) overlay.classList.remove('is-open');
      if (lastFocused && lastFocused.focus) {
        try { lastFocused.focus({ preventScroll: true }); } catch (err) { lastFocused.focus(); }
      }
      lastFocused = null;
    }
    unlockScroll();
  }

  function closeAllPanels() {
    openPanels.slice().forEach(closePanel);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-panel-open]');
    if (opener) {
      e.preventDefault();
      var target = $('#' + opener.getAttribute('data-panel-open'));
      if (target) { closeAllPanels(); openPanel(target); }
      return;
    }
    var closer = e.target.closest('[data-panel-close]');
    if (closer) {
      e.preventDefault();
      closePanel(closer.closest('.clp-drawer, .search-drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPanels();
    trapFocus(e);
  });

  window.clpPanels = { open: openPanel, close: closePanel, closeAll: closeAllPanels };

  /* --------------------------------------------------------------------
     Sabit başlık
     -------------------------------------------------------------------- */
  var headerWrapper = $('.header-wrapper');
  if (headerWrapper) {
    var setHeaderHeight = function () {
      root.style.setProperty('--header-height', headerWrapper.offsetHeight + 'px');
    };
    setHeaderHeight();
    window.addEventListener('resize', setHeaderHeight);

    var onHeaderScroll = function () {
      headerWrapper.classList.toggle('is-scrolled', window.scrollY > 60);
    };
    onHeaderScroll();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
  }

  /* --------------------------------------------------------------------
     Yukarı çık butonu
     -------------------------------------------------------------------- */
  var toTop = $('.scroll-to-top-btn');
  if (toTop) {
    var onToTopScroll = function () {
      toTop.classList.toggle('is-visible', window.scrollY > 400);
    };
    onToTopScroll();
    window.addEventListener('scroll', onToTopScroll, { passive: true });
    toTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* --------------------------------------------------------------------
     Bölüm giriş animasyonları
     -------------------------------------------------------------------- */
  var animObserver = null;
  if ('IntersectionObserver' in window) {
    animObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate--shown');
          animObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
  }

  function initAnimations(scope) {
    $$('.animate-section', scope || document).forEach(function (el) {
      if (animObserver) animObserver.observe(el);
      else el.classList.add('animate--shown');
    });
  }
  initAnimations();

  /* --------------------------------------------------------------------
     Adet seçici
     -------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.quantity__button');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.quantity');
    var input = $('.quantity__input', wrap);
    if (!input) return;
    var step = parseInt(input.step || '1', 10) || 1;
    var min = parseInt(input.min || '1', 10) || 0;
    var max = input.max ? parseInt(input.max, 10) : Infinity;
    var value = parseInt(input.value || '1', 10) || min;
    value = btn.name === 'plus' ? value + step : value - step;
    input.value = Math.min(max, Math.max(min, value));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* --------------------------------------------------------------------
     Sepet
     -------------------------------------------------------------------- */
  var cartDrawer = $('#CartDrawer');

  function refreshCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      var changed = el.textContent.trim() !== String(count);
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
      if (changed && count > 0) {
        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      }
    });
  }

  function renderCartDrawer(html) {
    if (!cartDrawer) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#CartDrawer .clp-drawer__inner');
    var current = $('.clp-drawer__inner', cartDrawer);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function fetchCartDrawer() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(renderCartDrawer);
  }

  function updateCartState() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        refreshCartCount(cart.item_count);
        return cart;
      });
  }

  window.clpCart = {
    add: function (formData, opts) {
      opts = opts || {};
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (!result.ok) throw new Error(result.data.description || result.data.message || 'Hata');
          return Promise.all([updateCartState(), fetchCartDrawer()]).then(function () {
            if (opts.openDrawer !== false && cartDrawer) openPanel(cartDrawer);
            return result.data;
          });
        });
    },
    change: function (line, quantity) {
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          refreshCartCount(cart.item_count);
          return fetchCartDrawer().then(function () { return cart; });
        });
    },
    refresh: function () { return Promise.all([updateCartState(), fetchCartDrawer()]); }
  };

  // Sepet panelindeki miktar / kaldırma işlemleri
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (!remove) return;
    e.preventDefault();
    remove.closest('.cart-item').style.opacity = '0.4';
    window.clpCart.change(parseInt(remove.getAttribute('data-cart-remove'), 10), 0);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-line]');
    if (!input) return;
    var line = parseInt(input.getAttribute('data-cart-line'), 10);
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) return;
    input.closest('.cart-item').style.opacity = '0.4';
    window.clpCart.change(line, qty);
  });

  /* --------------------------------------------------------------------
     Ürün formu — AJAX sepete ekleme
     -------------------------------------------------------------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-clp-product-form], form.product-form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var submit = form.querySelector('[type=submit]');
    var errorWrap = form.querySelector('.product-form__error-message-wrapper');
    var spinner = form.querySelector('.loading-overlay__spinner');

    if (submit) submit.setAttribute('disabled', 'disabled');
    if (spinner) spinner.classList.remove('hidden');
    if (errorWrap) errorWrap.setAttribute('hidden', 'hidden');

    var data = new FormData(form);
    data.append('sections', 'cart-drawer');

    window.clpCart.add(data)
      .catch(function (err) {
        if (errorWrap) {
          errorWrap.removeAttribute('hidden');
          var msg = errorWrap.querySelector('.product-form__error-message');
          if (msg) msg.textContent = err.message;
        }
      })
      .finally(function () {
        if (submit) submit.removeAttribute('disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  });

  /* --------------------------------------------------------------------
     Varyant seçici
     -------------------------------------------------------------------- */
  function initVariantPicker(scope) {
    $$('[data-clp-variants]', scope || document).forEach(function (picker) {
      if (picker.dataset.clpBound === '1') return;
      picker.dataset.clpBound = '1';

      var sectionId = picker.getAttribute('data-section');
      var dataEl = document.getElementById('ProductVariants-' + sectionId);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);

      function selectedOptions() {
        return $$('input[type=radio]:checked, select', picker).map(function (i) { return i.value; });
      }

      function findVariant(options) {
        return variants.find(function (v) {
          return v.options.every(function (opt, idx) { return opt === options[idx]; });
        });
      }

      function updateAvailability(options) {
        $$('.color-swatch input[type=radio]', picker).forEach(function (input) {
          var probe = options.slice();
          var group = input.closest('[data-option-index]');
          if (!group) return;
          probe[parseInt(group.getAttribute('data-option-index'), 10)] = input.value;
          var v = findVariant(probe);
          input.closest('.color-swatch').classList.toggle('color-swatch--unavailable', !v || !v.available);
        });
      }

      function update() {
        var options = selectedOptions();
        var variant = findVariant(options);
        updateAvailability(options);

        var form = document.getElementById('ProductForm-' + sectionId);
        var idInput = form && form.querySelector('input[name=id]');
        var submit = form && form.querySelector('[type=submit] .button__label');
        var submitBtn = form && form.querySelector('[type=submit]');

        if (!variant) {
          if (submitBtn) submitBtn.setAttribute('disabled', 'disabled');
          if (submit) submit.textContent = window.clpStrings.unavailable;
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (submitBtn) {
          if (variant.available) {
            submitBtn.removeAttribute('disabled');
            if (submit) submit.textContent = window.clpStrings.addToCart;
          } else {
            submitBtn.setAttribute('disabled', 'disabled');
            if (submit) submit.textContent = window.clpStrings.soldOut;
          }
        }

        // Fiyat
        var priceWrap = $('#ProductPrice-' + sectionId);
        if (priceWrap) {
          var cur = priceWrap.querySelector('.current');
          var old = priceWrap.querySelector('.old');
          var badge = priceWrap.querySelector('.discount-badge');
          var save = priceWrap.querySelector('.save-line');
          if (cur) cur.textContent = formatMoney(variant.price);
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          if (old) {
            old.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
            old.classList.toggle('hidden', !onSale);
          }
          if (badge) {
            if (onSale) {
              badge.textContent = '%' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + ' indirim';
              badge.classList.remove('hidden');
            } else badge.classList.add('hidden');
          }
          if (save) {
            if (onSale) {
              save.innerHTML = 'Bu üründe <strong>' + formatMoney(variant.compare_at_price - variant.price) + ' tasarruf</strong> ediyorsun.';
              save.classList.remove('hidden');
            } else save.classList.add('hidden');
          }
        }

        // Sabit çubuk fiyatı
        var stickyPrice = $('.sticky-atc__price');
        if (stickyPrice) {
          stickyPrice.innerHTML = formatMoney(variant.price) +
            (variant.compare_at_price > variant.price ? '<s>' + formatMoney(variant.compare_at_price) + '</s>' : '');
        }

        // Galeriyi varyant görseline getir (yalnızca küçük görsel butonunu hedefle)
        if (variant.featured_media_id) {
          var gallery = $('[data-clp-gallery][data-section="' + sectionId + '"]');
          if (gallery) {
            var thumb = gallery.querySelector('.product__thumbnail[data-media-id="' + variant.featured_media_id + '"]');
            if (thumb && thumb.getAttribute('aria-current') !== 'true') thumb.click();
          }
        }

        // Adres çubuğunu güncelle
        if (window.history.replaceState && variant.id) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }
  initVariantPicker();

  /* --------------------------------------------------------------------
     Ürün galerisi
     -------------------------------------------------------------------- */
  function initGallery(scope) {
    $$('[data-clp-gallery]', scope || document).forEach(function (gallery) {
      if (gallery.dataset.clpBound === '1') return;
      gallery.dataset.clpBound = '1';

      var slider = $('.product__media-slides', gallery);
      var slides = $$('.product__media-slide', gallery);
      var thumbs = $$('.product__thumbnail', gallery);
      if (!slider || !slides.length) return;

      function goTo(index, smooth) {
        var slide = slides[index];
        if (!slide) return;
        var target = slide.offsetLeft - slides[0].offsetLeft;
        if (smooth === false) slider.scrollLeft = target;
        else scrollXTo(slider, target, 480);
      }

      function setActive(index) {
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          goTo(i);
          setActive(i);
        });
      });

      var prev = $('.product__media-arrow--prev', gallery);
      var next = $('.product__media-arrow--next', gallery);
      function currentIndex() {
        var center = slider.scrollLeft + slider.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - slider.offsetLeft + s.clientWidth / 2 - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }
      if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, currentIndex() - 1)); });
      if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, currentIndex() + 1)); });

      var ticking = false;
      slider.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          setActive(currentIndex());
          ticking = false;
        });
      }, { passive: true });

      setActive(0);
    });
  }
  initGallery();

  /* --------------------------------------------------------------------
     Sabit sepete ekle çubuğu
     -------------------------------------------------------------------- */
  var stickyAtc = $('.sticky-atc');
  if (stickyAtc) {
    var trigger = $('.product-form__buttons');
    var onStickyScroll = function () {
      if (!trigger) return;
      var rect = trigger.getBoundingClientRect();
      stickyAtc.classList.toggle('is-visible', rect.bottom < 0);
    };
    onStickyScroll();
    window.addEventListener('scroll', onStickyScroll, { passive: true });

    var stickyBtn = $('[data-sticky-atc-submit]', stickyAtc);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = $('form[data-clp-product-form], form.product-form[action*="/cart/add"]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  /* --------------------------------------------------------------------
     Tema düzenleyici olayları
     -------------------------------------------------------------------- */
  document.addEventListener('shopify:section:load', function (e) {
    initAnimations(e.target);
    initVariantPicker(e.target);
    initGallery(e.target);
    $$('.animate-section', e.target).forEach(function (el) { el.classList.add('animate--shown'); });
  });

  /* --------------------------------------------------------------------
     Harici bağlantıları yeni sekmede aç
     -------------------------------------------------------------------- */
  window.addEventListener('load', function () {
    $$('a[href^="http"]').forEach(function (a) {
      if (a.hostname && a.hostname !== window.location.hostname) {
        a.target = '_blank';
        a.rel = 'noreferrer noopener';
      }
    });
  });
})();
